import { exporter } from '@sde/widgets-core/src/tools/exporter';
import { Widget } from './widget';

export const AccessRequestsBarWidget = exporter(Widget, {});
